import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-brief-address-label',
  templateUrl: './brief-address-label.component.html',
  styleUrl: './brief-address-label.component.scss'
})
export class BriefAddressLabelComponent implements OnInit {

  subscriberdetailsbrief: any;

    constructor(private dialogRef: MatDialogRef<BriefAddressLabelComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: DigisubservicesService,
      private cdr: ChangeDetectorRef,private fb: FormBuilder
    )
     { }


  ngOnInit(): void {
    debugger
    this.subscriberdetailsbrief = this.data['subscriberbrieflist'];
    console.log(this.subscriberdetailsbrief)
    console.log(this.data)
  }

  getStateName(state_name: any): string {
  if (!state_name) return '';

  if (Array.isArray(state_name)) {
    return state_name.map((s: any) => s.state_name || s).join(', ');
  }

  if (typeof state_name === 'object') {
    return state_name.state_name || '';
  }

  return state_name.toString();
}


 isNotBlank(value: any): boolean {
  return value !== null && value !== undefined && String(value).trim() !== '';
}

// getShortSubtype(subtype: string): string {
//   if (!subtype) return '';
//   return subtype.length <= 2 ? subtype : subtype.slice(0, 2);
// }


getShortSubtype(subtype: string): string {
  if (!subtype) return '';

  switch (subtype.trim()) {
    case 'अनामत': return 'अ';
    case 'आजीव': return 'आ';
    case 'ऑनलाईन अंक': return 'ऑ.अं';
    case 'वार्षिक': return 'वा';
    case 'त्रैवार्षिक': return 'त्रै';
    case 'देणगी': return 'दे';
    case 'पंचवार्षिक': return 'पं';
    case 'मुदत ठेव (पंचवार्षिक वर्गणीदार)': return 'मु';
    case 'रा.स्व. संघ ग्रंथ': return 'रा.स्व. संघ';
    case 'रा.स्व.ग्रंथ': return 'रा.स्व.';
    case 'रा.स्व.संघ ग्रंथ': return 'रा.स्व.संघ ग्रं';
    case 'रामसेवक ग्रंथयात्री': return 'रा.ग्रं';
    case 'राष्ट्रोत्थान 2100': return 'रा-2100';
    case 'राष्ट्रोत्थान 2500': return 'रा-2500';
    case 'लोकनेता गंथयात्री वार्षिक': return 'लो.गं.वा';
    case 'लोकनेता ग्रंथयात्री वार्षिक': return 'लो.ग्रं.वा';
    case 'सप्रेम भेट - संपादकीय विभाग': return 'स.सं.वि';
    case 'सप्रेम भेट संघ परिवार': return 'स.सं.प';
    case 'सप्रेम भेट हितचिंतक': return 'स.भे.हि';
    case 'सप्रेम भेट-जाहिरात प्रतिनीधी': return 'स.भे.जा.प्र';
    case 'सप्रेम भेट-वर्गणीदार प्रतिनीधी': return 'स.भे.व.प्र';
    case 'सप्रेम भेट-संघ परिवार': return 'स.भे.सं.प';
    case 'हितचिंतक सप्रेम भेट': return 'हि.स.भे';
    case 'हिंदुत्व': return 'हिं';
    case 'हिंदुत्व- 2': return 'हिं-2';

    default:
      // fallback → take first 2 chars safely
      return subtype.length <= 2 ? subtype : subtype.slice(0, 2);
  }
}

  

}
